const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 60,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 80,
	},
	{
		prop: "CountryManName",
		label: "全国总监",
		columnwidth: 100,
	},
	{
		prop: "RegionManName",
		label: "大区经理",
		columnwidth: 150,
	},
	{
		prop: "AreaManName",
		label: "地区经理",
		columnwidth: 150,
	},
	{
		prop: "LEVEL3",
		label: "Level3",
		columnwidth: 150,
	},
	{
		prop: "MoneyQuota",
		label: "年度金额BP",
		columnwidth: 100,
	},
	{
		prop: "JanMoneyQuota",
		label: "一月金额指标",
		columnwidth: 120,
	},
	{
		prop: "FebMoneyQuota",
		label: "二月金额指标",
		columnwidth: 120,
	},
	{
		prop: "MarMoneyQuota",
		label: "三月金额指标",
		columnwidth: 120,
	},
	{
		prop: "AprMoneyQuota",
		label: "四月金额指标",
		columnwidth: 120,
	},
	{
		prop: "MayMoneyQuota",
		label: "五月金额指标",
		columnwidth: 120,
	},
	{
		prop: "JunMoneyQuota",
		label: "六月金额指标",
		columnwidth: 120,
	},
	{
		prop: "JulMoneyQuota",
		label: "七月金额指标",
		columnwidth: 120,
	},
	{
		prop: "AugMoneyQuota",
		label: "八月金额指标",
		columnwidth: 120,
	},
	{
		prop: "SepMoneyQuota",
		label: "九月金额指标",
		columnwidth: 120,
	},
	{
		prop: "OctMoneyQuota",
		label: "十月金额指标",
		columnwidth: 120,
	},
	{
		prop: "NovMoneyQuota",
		label: "十一月金额指标",
		columnwidth: 120,
	},
	{
		prop: "DecMoneyQuota",
		label: "十二月金额指标",
		columnwidth: 120,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 130,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 130,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 130,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 130,
	}
];
export default headerData;
